/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2023, Zumper
 * @description stripUnit.ts
 */

/**
 * returns the unit number from an address string
 *
 * @param {string} address - an address, e.g. 123 Main St
 * @returns {string} - returns the unit number if present. Otherwise return unmodified address
 */
export const stripUnit = (address: string): string => {
  return address.replace(/^.*# *(.*?) *$/, '$1')
}
